import Firebase from 'firebase/app'
import credentials from './credentials'

export const App = Firebase.initializeApp(credentials.config);



// WEBPACK FOOTER //
// ./src/firebase/app.js